import { useEffect, useState, useCallback } from 'react';
import { sharedGet } from '@/lib/sharedGet';
import { canVerify } from '@/auth/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Polls the current-cycle unverified submission count for verify-capable users. */
export function useUnverifiedCount(user) {
  const [count, setCount] = useState(0);
  const enabled = canVerify(user);

  const refresh = useCallback(async () => {
    if (!enabled) { setCount(0); return; }
    try {
      const data = await sharedGet(`${API}/forms/unverified-count`);
      setCount(data?.count || 0);
    } catch (_e) { /* ignore transient errors */ }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh, enabled]);

  return count;
}
